import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useConfirmStore = defineStore('confirm', () => {
  const isOpen = ref(false)
  const title = ref('')
  const message = ref('')
  const confirmLabel = ref('Confirm')
  const cancelLabel = ref('Cancel')
  const severity = ref('info') // 'info' or 'error' (which becomes red in ModalDialog)

  let onConfirmCallback = null
  let onCancelCallback = null

  const require = options => {
    title.value = options.header || 'Confirmation'
    message.value = options.message || 'Are you sure?'
    confirmLabel.value = options.acceptLabel || 'Confirm'
    cancelLabel.value = options.rejectLabel || 'Cancel'
    severity.value = options.severity || 'info'

    onConfirmCallback = options.accept
    onCancelCallback = options.reject

    isOpen.value = true
  }

  const confirm = () => {
    if (onConfirmCallback) onConfirmCallback()
    isOpen.value = false
  }

  const cancel = () => {
    if (onCancelCallback) onCancelCallback()
    isOpen.value = false
  }

  return {
    isOpen,
    title,
    message,
    confirmLabel,
    cancelLabel,
    severity,
    require,
    confirm,
    cancel,
  }
})
